import { CommonBridge } from "../commonBridge";
import { CommonBridgeMockService } from "../CommonBridgeMockService";

const MockService = new CommonBridgeMockService();

export const commonWeb: CommonBridge = {
  getAccessToken: () => MockService.getAccessToken(),
  getAppParams: () => MockService.getAppParams(),
};
